import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";
import ArtikelForm from "./Components/form";
import { fetchOneArtikel, updateArtikel } from "../Reducers/actions";

const ArtikelEditPage = () => {
  const [loaded, setLoaded] = useState(false);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { id } = useParams();
  const artikel = useSelector((state) => state.gastenverbruik.artikel);

  useEffect(() => {
    setLoaded(false);
    dispatch(fetchOneArtikel(id)).then(() => {
      setLoaded(true);
    });
  }, [dispatch, id]);

  const submit = (vals) => {
    dispatch(updateArtikel(id, vals)).then((data) => {
      if (data.type === "ARTIKEL_ERROR") {
        alert(data.payload);
        return false;
      } else {
        navigate("/gastenverbruik/artikelen");
      }
    });
  };

  return (
    <div className="box box-default">
      <div className="box-header with-border">
        <h3 className="box-title">Artikel Wijzigen</h3>
      </div>
      
      <div className="row">
        <div className="col-md-12 no-float">
          <div className="box box-primary">
            <div className="box-body box-profile">
              {loaded && <ArtikelForm onSubmit={submit} initialValues={artikel} />}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ArtikelEditPage;